import axios from 'axios';
import Cookies from 'js-cookie';

import { DYNAMIC_YIELD_COOKIES } from 'state/constants';

import { BASE_URL, COLLECT_BASE_URL, TIMEOUT_MS } from './constants';

const DynamicYieldAPI = class {
  static choose(selector, userIp) {
    const { ...recommendationContext } = window.DY.recommendationContext;

    if (!recommendationContext?.data) {
      recommendationContext.data = [];
    }
    const dyApiPreviewParam = new URLSearchParams(window.location.search).get('dyApiPreview');
    const selectorWithPreview = {
      ...selector,
    };

    if (dyApiPreviewParam) {
      selectorWithPreview.preview = {
        ids: [dyApiPreviewParam],
      };
    }

    return axios.post(
      `${BASE_URL}/serve/user/choose`,
      {
        selector: selectorWithPreview,
        user: {
          dyid: Cookies.get(DYNAMIC_YIELD_COOKIES.SERVER),
          dyid_server: Cookies.get(DYNAMIC_YIELD_COOKIES.SERVER),
        },
        session: { dy: Cookies.get(DYNAMIC_YIELD_COOKIES.SESSION) },
        context: {
          page: {
            ...recommendationContext,
            location: window.location.href,
          },
          device: {
            userAgent: window.navigator.userAgent,
            ip: userIp,
          },
        },
        options: {
          returnAnalyticsMetadata: true,
        },
      },
      {
        headers: {
          'DY-API-KEY': window.DY.apiKey,
        },
        timeout: TIMEOUT_MS,
      }
    );
  }

  static reportClick(engagement) {
    return axios.post(
      `${COLLECT_BASE_URL}/collect/user/engagement`,
      {
        user: {
          dyid: Cookies.get(DYNAMIC_YIELD_COOKIES.SERVER),
          dyid_server: Cookies.get(DYNAMIC_YIELD_COOKIES.SERVER),
        },
        session: { dy: Cookies.get(DYNAMIC_YIELD_COOKIES.SESSION) },
        engagements: [...engagement],
      },
      {
        headers: {
          'DY-API-KEY': window.DY.apiKey,
        },
      }
    );
  }
};

export default DynamicYieldAPI;
